// central configuration values, read from process.env without defaults
// absence of a value will result in empty string/undefined so callers
// can decide how to behave or fail fast.

export const MQTT_URL = process.env.MQTT_URL || '';
export const MQTT_BROKER_URL = process.env.MQTT_BROKER_URL || '';
export const MQTT_USERNAME = process.env.MQTT_USERNAME || process.env.MQTT_USER || '';
export const MQTT_PASSWORD = process.env.MQTT_PASSWORD || process.env.MQTT_PASS || '';
export const REDIS_URL = process.env.REDIS_URL || '';

// DATABASE_URL normalization and fallback --------------------------------------------------
// Prisma (and other clients) expect a valid URL string. unencoded special
// characters in the password (`&`, `?`, etc.) will cause `new URL(raw)` to
// throw, which is why we previously saw "invalid DATABASE_URL; using raw
// string" in the logs. normalizeUrl will attempt to parse the value and
// percent‑encode the password if necessary; if the string is completely
// unparsable we fall back to building a URL from the individual
// POSTGRES_* environment variables.
function normalizeUrl(raw?: string): string {
  if (!raw) return '';
  try {
    const u = new URL(raw);
    if (u.password) {
      // ensure password is properly encoded
      u.password = encodeURIComponent(decodeURIComponent(u.password));
    }
    return u.toString();
  } catch (e) {
    // try a simplistic attack: escape everything after the colon in the auth
    // portion and retry. this handles cases where only the password contains
    // unencoded characters.
    const authMatch = raw.match(/^(.*:\/\/)([^@]+)@(.*)$/);
    if (authMatch) {
      const prefix = authMatch[1];
      const auth = authMatch[2];
      const rest = authMatch[3];
      const parts = auth.split(':');
      if (parts.length === 2) {
        const user = parts[0];
        const pass = encodeURIComponent(parts[1]);
        const rebuilt = `${prefix}${user}:${pass}@${rest}`;
        try {
          const u2 = new URL(rebuilt);
          if (u2.password) {
            u2.password = encodeURIComponent(decodeURIComponent(u2.password));
          }
          return u2.toString();
        } catch {}
      }
    }

    console.warn('invalid DATABASE_URL; using raw string');
    return raw;
  }
}

function buildUrlFromEnv(): string {
  if (!process.env.POSTGRES_HOST || !process.env.POSTGRES_DB) return '';
  const user = encodeURIComponent(process.env.POSTGRES_USER || '');
  const pass = encodeURIComponent(process.env.POSTGRES_PASSWORD || '');
  const host = process.env.POSTGRES_HOST;
  const port = process.env.POSTGRES_PORT || '5432';
  const db = process.env.POSTGRES_DB;
  const ssl = process.env.POSTGRES_SSL === 'true' ? '?sslmode=require' : '';
  return `postgresql://${user}:${pass}@${host}:${port}/${db}${ssl}`;
}

export const DATABASE_URL =
  normalizeUrl(process.env.DATABASE_URL) || buildUrlFromEnv();

export const QDRANT_URL = process.env.QDRANT_URL || '';
export const OLLAMA_URL = process.env.OLLAMA_URL || '';
export const PORT = parseInt(process.env.PORT || '4000', 10);

export const WORKER_QUEUE = process.env.WORKER_QUEUE || '';
export const AGENT_QUEUE = process.env.AGENT_QUEUE || '';
